import { render, staticRenderFns } from "./AdminDetails.vue?vue&type=template&id=08904eda&scoped=true&"
import script from "./AdminDetails.vue?vue&type=script&lang=js&"
export * from "./AdminDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08904eda",
  null
  
)

export default component.exports